import { render, staticRenderFns } from "./szsx-detail.vue?vue&type=template&id=531a44fd&"
import script from "./szsx-detail.vue?vue&type=script&lang=ts&"
export * from "./szsx-detail.vue?vue&type=script&lang=ts&"
import style0 from "./szsx-detail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports